import { cn } from 'cn'
import type { ComponentProps, ElementType } from 'react'

export const iconSquareStyle = cn(
  'flex aspect-square size-6 shrink-0 items-center justify-center rounded-sm border bg-muted p-1 text-foreground [>*]:size-full'
)

export type IconSquareProps = ComponentProps<'span'> & {
  icon: ElementType
}

export const IconSquare = ({
  icon: Icon,
  className,
  ...rest
}: IconSquareProps) => (
  <span className={cn(iconSquareStyle, className)} {...rest}>
    <Icon />
  </span>
)
